import { gql } from "@apollo/client";

export const FETCH_STOCK_SUPPLIERS = gql`
  query FETCH_STOCK_SUPPLIERS {
    suppliers(forChinaStock: true, withRanking: true) {
      id
      nickName
    }
  }
`;

export const FETCH_SUPPLIER_CHINA_STOCK_PRODUCTS = gql`
  query FETCH_CHINA_STOCK_PRODUCTS($supplierId: ID!) {
    supplier: factory(id: $supplierId) {
      id
      nickName
    }
    products(forChinaStockSupplierId: $supplierId) {
      results {
        id
        number
        name
      }
    }
  }
`;

export const FETCH_STOCK_SUPPLIER_OVERVIEW = gql`
  query FETCH_STOCK_SUPPLIER_OVERVIEW($supplierId: ID!) {
    stockSupplierOverview(supplierId: $supplierId)
  }
`;
